import React, {Component} from 'react';
import _size from 'lodash/size';
import {Helmet} from 'react-helmet';

class MetaTags extends Component {

    render() {
        const {title, tags, metaDescriptions, isPlaces} = this.props;
        return (
            <Helmet>
                {title && !isPlaces && <title>{title}</title>}
                {metaDescriptions && !isPlaces && <meta name="description" content={metaDescriptions}/>}
                {_size(tags) && !isPlaces && <meta name="keywords" content={tags.join(',')}/>}
            </Helmet>
        )
    }
}

export default MetaTags;
